import type { ThemePreset } from "../types";
import { forestExternalPreset } from "./forest-external";
import { forestAgencyPreset } from "./forest-agency";
import { forestInternalPreset } from "./forest-internal";
import { forestAlkemyPlusPreset } from "./forest-alkemy-plus";

const presetRegistry = new Map<string, ThemePreset>();

// Register built-in presets
presetRegistry.set(forestExternalPreset.name, forestExternalPreset);
presetRegistry.set(forestAgencyPreset.name, forestAgencyPreset);
presetRegistry.set(forestInternalPreset.name, forestInternalPreset);
presetRegistry.set(forestAlkemyPlusPreset.name, forestAlkemyPlusPreset);

/** Get a preset by name. Returns `undefined` if not found. */
export function getPreset(name: string): ThemePreset | undefined {
  return presetRegistry.get(name);
}

/** Register a custom preset (or override a built-in one). */
export function registerPreset(preset: ThemePreset): void {
  presetRegistry.set(preset.name, preset);
}

/** List all registered preset names. */
export function getAvailablePresets(): string[] {
  return Array.from(presetRegistry.keys());
}

export { forestExternalPreset, forestAgencyPreset, forestInternalPreset, forestAlkemyPlusPreset };
